document.addEventListener("DOMContentLoaded", () => {  
    const tabButtons = document.querySelectorAll(".tab-button");
    const sections = Array.from(
        document.querySelectorAll(".featured-collection-section")
    );

    function hideAllSections() {
        sections.forEach((section) => {
            section.style.display = "none";
        });
    }

    function showSection(targetSection) {
        targetSection.style.display = "block";
    }

    function removeActiveClass() {
        tabButtons.forEach((button) => button.classList.remove("active"));
    }

    function scrollToTabs() {
        const tabsContainer = document.querySelector(".scrollable-tabs-container");
        if (tabsContainer) {
            setTimeout(() => {
                tabsContainer.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }, 300);
        }
    }

    function updatePLPBanner(collectionAttr) {
        const allBannerImages = document.querySelectorAll(".plp-banner-image");
        allBannerImages.forEach((img) => {
            img.style.display =
                img.getAttribute("data-collection") === collectionAttr
                    ? "block"
                    : "none";
        });
    }

    function scrollActiveTabIntoContainerView(button) {
        if (!button) return;
        const tabsContainer = button.closest(".scrollable-tabs-container");
        if (tabsContainer) {
            setTimeout(() => {
                const buttonLeft = button.offsetLeft;
                const buttonWidth = button.offsetWidth;
                const containerWidth = tabsContainer.offsetWidth;
                const scrollPosition = buttonLeft - (containerWidth / 2) + (buttonWidth / 2);
                tabsContainer.scrollTo({
                    left: Math.max(0, scrollPosition),
                    behavior: "smooth",
                });
            }, 50);
        }
    }

    function activateTab(collectionAttr, shouldScroll = true) {
        removeActiveClass();
        hideAllSections();
        const button = Array.from(tabButtons).find(
            (button) => button.getAttribute("data-collection") === collectionAttr
        );
        const targetSection = sections.find((section) =>
            section.querySelector(
                '.pdp-featured-collection[data-collection="' + collectionAttr + '"]'
            )
        );
        if (button && targetSection) {
            button.classList.add("active");
            showSection(targetSection);
            updatePLPBanner(collectionAttr);
            scrollActiveTabIntoContainerView(button);
            if (shouldScroll && window.innerWidth > 991) {
                setTimeout(scrollToTabs, 100);
            }
        }

        const event = new CustomEvent("tabChanged", {
            detail: {
                collection: collectionAttr,
            },
        });

        document.dispatchEvent(event);
    }

    const urlParams = new URLSearchParams(window.location.search);
    const flag = urlParams.get("flag");

    if (flag) {
        setTimeout(() => {
            activateTab(flag, true);
        }, 100);
    }

    tabButtons.forEach((button) => {
        button.addEventListener("click", function () {
            const collectionAttr = this.getAttribute("data-collection");
            activateTab(collectionAttr, false);

            const newUrl = new URL(window.location);
            newUrl.searchParams.set("flag", collectionAttr);
            window.history.replaceState(null, "", newUrl);
        });
    });

    const path = window.location.pathname;
    if (!flag && path.endsWith('/collections/all-products')) {
        const allProductsTab = document.querySelector('.tab-button[data-collection="all-products"]');
        if (allProductsTab) {
            allProductsTab.click();
            setTimeout(scrollToTabs, 200);
        }
    }

    window.addEventListener("popstate", function () {
        const currentParams = new URLSearchParams(window.location.search);
        const currentFlag = currentParams.get("flag");
        if (currentFlag) {
            activateTab(currentFlag, true);
        }
    });
});
